import TextDecorationModule from './text-decoration.module'

export default TextDecorationModule
